import {Component, ViewChild} from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {CustomLoadingProvider} from "../../../providers/custom-loading/custom-loading";
import {MyAlertProvider} from "../../../providers/my-alert/my-alert";
import {GroupProvider} from "../../../providers/group/group";
import {UtilProvider} from "../../../providers/util/util";
import {SensitiveService} from "../sensitive.service";
import {SensitiveListPage} from "../sensitive-list/sensitive-list";
import {global} from "../../../environments/global";
declare var $:any;

/**
 * Generated class for the SensitiveStep_2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sensitive-step-2',
  templateUrl: 'sensitive-step-2.html',
})
export class SensitiveStep_2Page {

  @ViewChild('sensitiveInput') sensitiveInput;

  is_show_cover = global.shangCengFlag;

  global = global;

  max_count ;
  sensitive;

  //已选择的微信群
  // choosedChatrooms = [];

  /*choosedChatrooms = [{
    "avatar_url": "https://wx.qlogo.cn/mmcrhead/LwcbhAmMnZCeRxhxA4d0MEawXCgicPicPkicicLgam2pw1SZicEzZHDYZMLDq7UFrlhvGVgkNTsDMneIN90ph3avkdD1db8xCw3qn/0",
    "chatroom_id": "5ad6b20bf5d7e2132f6064c1",
    "chatroom_member_count": 4,
    "chatroom_nickname": "aaaaaaaaaaaaaa",
    "chatroom_status": 0,
    "chatroomname": "4606272581@chatroom"
  },
    {
      "avatar_url": "https://wx.qlogo.cn/mmcrhead/bj9JGugn6Uexvibdibuqg4AKPWic7S6wFnubricNpHnLpTvkZWM2UNg1MH7doztZB3MQjWibXxEAecMRRib6jBdm1ZKDPWN2PdS675/0",
      "chatroom_id": "5ad6b216f5d7e2132f6064c2",
      "chatroom_member_count": 7,
      "chatroom_nickname": "bbbbbbbbbbbb",
      "chatroom_status": 0,
      "chatroomname": "4505273062@chatroom"
    }
  ];*/

  //是否是新建
  isCreate: boolean;

  //新的敏感词
  newSensitive = '';


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public util: UtilProvider,
              public groupService: GroupProvider,
              private csLoader: CustomLoadingProvider,
              private myAlert: MyAlertProvider,
              public alertCtrl: AlertController,
              public ssService: SensitiveService) {
    this.sensitive = {};
    try {
      this.sensitive['chatroom_list'] = this.navParams.data['chatroom_list'] || [];
      this.sensitive['rule_id'] = this.navParams.data['rule_id'];
      this.sensitive['remark'] = this.navParams.data['remark'];
      this.sensitive['cover'] =  this.navParams.data['cover'] || 0;
      this.sensitive['sensitive_word_list'] = this.navParams.data['sensitive_word_list'] || [];
    }
    catch (e){
      console.log(e);
    }

    // this.choosedChatrooms =

    // this.ruleId = this.navParams.data['rule_id'];
    // this.remark = this.navParams.data['remark'];
    // this.cover = this.navParams.data['cover'] || 0;
    // this.sensitives = this.navParams.data['sensitive_word_list'] || [];
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad SensitiveStep_2Page');
    // console.log(this.choosedChatrooms);
    // console.log(this.isCreate);

    // setTimeout(()=>{
      //输入框聚焦
      // this.sensitiveInput.nativeElement.trigger('focus');
      // console.log($('#label'));
      // $('#label').trigger('click');
    // });
  }

  addSensitive() {
    if (this.newSensitive != '') {
      if (
        this.sensitive.sensitive_word_list.every(
          item => item != this.newSensitive
        )
      ) {
        this.sensitive.sensitive_word_list.push(this.newSensitive);
      } else {
        this.util.alertHintMsg(this.alertCtrl, '提示', '您已经输入该监控内容');
      }
      this.newSensitive = '';
    }
  }

  /**
   * 删除敏感词*/
  deleteSensitive(e, index) {
    e.stopPropagation();
    this.sensitive.sensitive_word_list.splice(index, 1);
  }

  submit() {
    if(this.sensitive.sensitive_word_list.length>0 && (global.shangCengFlag || this.sensitive.chatroom_list.length>0 )){
      this.csLoader.showLoader();

      this.ssService.editSensitive(this.sensitive).subscribe(res=>{
        this.csLoader.dismissLoader();
        this.util.myNav(this.navCtrl, 'SensitiveListPage');

      }, err=>{
        this.csLoader.dismissLoader();
      });
    } else if(this.sensitive.sensitive_word_list.length==0){
      this.util.alertHintMsg(this.alertCtrl, '提示', '请输入监控内容');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/sensitive/sensitive-step-2/sensitive-step-2.ts